export class AudienceAIChatRequest {
  input_message: string;
  data_universe_id: string;
  business_unit_id?: string;
}

export class Conversation {
  id: string;
  user_session_id: string;
  user_id: string;
  tenant_code: string;
  product_type: string;
  start_time: number;
  modified_time: number;
  end_time?: number;
  data_universe_id: string;
  conversation_state: ConversationState;
  chat_history: BaseMessage[] = [];
}

export class AudienceAIChatResponse {
  ai_message: BaseMessage;
  conversation_state: ConversationState;
  response: { [key: string]: string };
}

export class ConversationState {
  audience_preview: AudiencePreviewInfo;
  genai_request_id?: string;
  audience_definition_id?: string;
  count_job_id?: string;
  preview_job_id?: string;
  audience_count?: { [key: string]: string };
  query_from_text?: string;
}

export class AudiencePreviewInfo {
  audience_name?: string;
  description?: string;
  channel?: string;
  audience_type?: string;
  dedupe?: string;
  audience_query?: string;
}

export enum AudienceAIResponseType {
  OK = 'OK',
  ERROR = 'ERROR'
}

export class AdditionalKwargs {
  audience_definition_id?: string;
  genai_request_id?: string;
  count_job_id?: string;
  preview_job_id?: string;
  sqlClause?: string;
  sampleData?: any[];
  tableHeaders?: string[];
  feedback?: Feedback;
  created_at?: Date;
}

export class Feedback {
  currentFeedbackRating = 0;
  previousFeedbackRating = 0;
  showNotification = false;
  isFeedbackCommentGiven = false;
}

export class ResponseMetadata {
  response_type: string;
}

export class BaseMessage {
  type: UserType;
  content: any;
  additional_kwargs: AdditionalKwargs;
  response_metadata: ResponseMetadata;
}

export class CountResult {
  requestId: string;
  count: number;
  status: string;
  otherIdentityTypeCounts: { [key: string]: string };
}

export class PreviewResult {
  schema: { [key: string]: string };
  data: { [key: string]: string };
  status: string;
}

export class JobResponse {
  version: number;
  createdBy: string;
  createdDate: Date;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  id: string;
  cabContextId: string;
  jobType: JobType;
  requestParams: { [key: string]: string };
  result: CountResult | PreviewResult;
  status: string;
  submittedAt: Date;
  startedAt: Date;
  completedAt: Date;
  cabTransactionId: string;
}

export class PickListResponse {
  name: string;
  values: PickListValues[];
}

export class PickListValues {
  id: string;
  displayName: string;
}

export enum JobType {
  COUNT = 'Count',
  PREVIEW = 'Preview'
}

export enum UserType {
  HUMAN = 'human',
  ASSISTANT = 'ai'
}
